import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IButtonProps } from 'components/button/ButtonProps';
import { DefaultButton } from 'components/button/DefaultButton';

export type IconButtonProps = IButtonProps & {
    icon: IconDefinition;
};

export function IconButton({ children, icon, ...buttonProps }: IconButtonProps) {
    return (
        <DefaultButton {...buttonProps}>
            <FontAwesomeIcon className="pr-10" icon={icon} />
            {children}
        </DefaultButton>
    );
}
